import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=fd495b28&"
import script from "./ProductGallery.vue?vue&type=script&lang=js&"
export * from "./ProductGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd495b28')) {
      api.createRecord('fd495b28', component.options)
    } else {
      api.reload('fd495b28', component.options)
    }
    module.hot.accept("./ProductGallery.vue?vue&type=template&id=fd495b28&", function () {
      api.rerender('fd495b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductGallery.vue"
export default component.exports